import "./ServicePage.scss";
import "components/ModalForm/ModalForm";

(function () {
    if (document.querySelectorAll(".js-service-page").length > 0) {

        const servicePage = {
            init: function () {
                servicePage.addEventListeners();
            },
            addEventListeners: () => {
                const showMoreBtn = document.getElementById("showMoreBtn");
                const showLessBtn = document.getElementById("showLessBtn");

                const hiddenServices = document.querySelectorAll(".service-hidden");

                if (hiddenServices.length) {
                    showMoreBtn.classList.remove("hidden");

                    showMoreBtn.addEventListener("click", () => {
                        hiddenServices.forEach((service) => {
                            service.classList.remove("hidden");
                        })

                        showMoreBtn.classList.add("hidden");
                        showLessBtn.classList.remove("hidden");
                    })

                    showLessBtn.addEventListener("click", () => {
                        hiddenServices.forEach((service) => {
                            service.classList.add("hidden");
                        })

                        showMoreBtn.classList.remove("hidden");
                        showLessBtn.classList.add("hidden");
                    })
                }
            }
        };

        servicePage.init();
    }
})();
